import { setRange } from './helpers';

export const setLandArea = setRange('site');
